/**
 * Store admin — quotes list (Commerce, M4).
 * @see prototype/store/admin/all.html#quotes-list
 */
import { createFileRoute } from "@tanstack/react-router";
import { QuotesListPage } from "../../../../../features/store/quotes/quotes-list-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/quotes/")({
  component: QuotesListPage,
});
